export const PERFIS = {
    ADMINISTRADOR: 1,
    AGENDAMENTO: 2,
    PROFISSIONAL: 3
  };
  